module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-11-8b2ad4fb.svg";